import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@la/ds-ui-components';
import { breakpointQueries, useMediaQuery } from '@la/shared-components';
import Portal from 'components/Portal/Portal';
import { useRegistrationAnalytics } from 'lib/context/RegistrationAnalyticsContext';
import {
  injectRegistrationAnalyticsData,
  parseHTML,
} from 'lib/utils/analytics';
import { useGetSiteTrackingSettingsQuery } from 'redux/services/siteInfo';
import PlayAppLockup from 'domains/ConsolidatedCheckout/PlayAppLockup/PlayAppLockup';
import ConfirmationRollup from '../ConfirmationRollup/ConfirmationRollup';
import styles from './ConfirmationPageContent.module.scss';

/* ConfirmationPageContent */
export default function ConfirmationPageContent({
  siteId,
}: Readonly<{
  siteId: string | null;
}>) {
  const { data: siteTrackingSettings } = useGetSiteTrackingSettingsQuery(
    { siteId: siteId ? parseInt(siteId) : -1 },
    { skip: !siteId }
  );

  const { registrationAnalyticsData } = useRegistrationAnalytics();

  useEffect(() => {
    if (registrationAnalyticsData) {
      registrationAnalyticsData.forEach(injectRegistrationAnalyticsData);

      if (siteTrackingSettings?.conversionTrackingRegistration) {
        document.body.append(
          parseHTML(siteTrackingSettings.conversionTrackingRegistration)
        );
      }
    }
  }, [registrationAnalyticsData, siteTrackingSettings]);

  return (
    <>
      <div className={styles.confirmationPageContainer}>
        <ConfirmationMessage />
        <ConfirmationRollup />
      </div>
      <Portal parentId="#mp-footer-portal">
        <PlayAppLockup />
      </Portal>
    </>
  );
}
/* */

export function ConfirmationMessage() {
  const navigate = useNavigate();
  const isTabletLandscapeUp = useMediaQuery(
    breakpointQueries.tabletLandscapeUp
  );

  function navigateToDashboard() {
    navigate('/dashboard');
  }

  return (
    <div className={styles.confirmationMessage}>
      <h2 className={styles.confirmationHead}>Registration complete!</h2>
      <p className={styles.messageBody}>
        You will receive a confirmation email in your inbox shortly. If you have
        any questions, contact the tournament administrator.
      </p>
      <p className={styles.subtitle}>What's next?</p>
      <p className={styles.subtitleContent}>
        Your assigned Team Rep(s) will receive an invitation and further
        instructions.
      </p>
      <p className={styles.subtitleContent}>
        To check on a team's registration status, visit the Member Dashboard.
      </p>
      <Button
        size="medium"
        onClick={navigateToDashboard}
        variant="primary"
        width={isTabletLandscapeUp ? undefined : 'auto'}
      >
        Visit dashboard
      </Button>
    </div>
  );
}
